import React from 'react';
import { Switch as AntSwitch } from 'antd';
import type { SwitchProps } from 'antd';
import clsx from 'clsx';

export const Switch = ({ className, ...props }: SwitchProps) => (
  <AntSwitch {...props} className={clsx('wk-switch', className)} />
);
